// Letter sets as 26-bit masks, and a per-list index of word masks, so legality and phoenix checks
// are a single AND instead of a scan over letters.
import type { WordList } from '@wbwl/words'
import { VOWELS } from './constants.ts'

export const bit = (letter: string): number => 1 << (letter.charCodeAt(0) - 65)

export function maskOf(letters: Iterable<string>): number {
  let m = 0
  for (const l of letters) m |= bit(l)
  return m
}

const VOWEL_MASK = maskOf(VOWELS)

export function vowelsLeft(burned: number): number {
  let n = 0
  for (const v of VOWELS) if (!(burned & bit(v))) n++
  return n
}

export const outOfVowels = (burned: number): boolean => (burned & VOWEL_MASK) === VOWEL_MASK

export interface WordIndex {
  readonly words: readonly string[]
  /** Letters used by each word. */
  readonly masks: Uint32Array
  /** Whether each word has five different letters (the phoenix needs that). */
  readonly distinct: Uint8Array
}

const indexes = new WeakMap<WordList, WordIndex>()

export function indexOf(list: WordList): WordIndex {
  let index = indexes.get(list)
  if (!index) {
    const words = list.words
    const masks = new Uint32Array(words.length)
    const distinct = new Uint8Array(words.length)
    words.forEach((w, i) => {
      masks[i] = maskOf(w)
      distinct[i] = new Set(w).size === w.length ? 1 : 0
    })
    index = { words, masks, distinct }
    indexes.set(list, index)
  }
  return index
}
